module.exports = __webpack_public_path__ + "img/arrow-right-black.7f14e315.png";